import { Injectable } from '@angular/core';
import { GridsterConfig } from 'angular-gridster2';
import { DeviceDetectorService } from '../../common/device-detection/services/device-detector.service';
import { siteSpecificData } from '../../../environments/site-specific-data';

@Injectable()
export class GridsterConfigProviderService {

  constructor(private readonly deviceDetectorService: DeviceDetectorService) { }

   getMobileBreakpoint(): number {

    if (this.isMobile()) {
      return siteSpecificData.mobileBreakpoint ? siteSpecificData.mobileBreakpoint : Number.MAX_VALUE;
    }

    return 769;
  }

  isResizable(): boolean {
    return !this.isMobile();
  }

  isDraggable(): boolean {
    return !this.isMobile();
  }

  getGridsterConfig(): GridsterConfig {


    const options: GridsterConfig = {
      margin: 15,
      gridType: 'scrollVertical',
      compactType: 'compactLeft&Up',
      pushItems: true,
      disablePushOnDrag: false,
      disablePushOnResize: false,
      pushResizeItems: false,
      swap: true,
      mobileBreakpoint: this.getMobileBreakpoint(),
      keepFixedHeightInMobile: true,
      minCols: 12,
      maxCols: 12,
      fixedColWidth: 105,
      fixedRowHeight: 105,
      maxItemCols: 100,
      minItemCols: 1,
      maxItemRows: 100,
      minItemArea: 1,
      defaultItemRows: 3,
      defaultItemCols: 3,
      displayGrid: 'none',
      draggable: {
        enabled: this.isDraggable(),
        ignoreContentClass: 'widget-content',
        ignoreContent: true,
        dragHandleClass: 'panel-heading',
        //start: (item, component, evt) => { this.dragStart(item, component, evt); },
        //stop: (item, component, evt) => { this.drop(item, component, evt); }
      },
      resizable: {
        enabled: this.isResizable(), // enable/disable resizable items
        handles: {
          s: true,
          e: true,
          n: true,
          w: true,
          se: true,
          ne: true,
          sw: true,
          nw: true
        } // resizable edges of an item
      }
    };
    return options;
  }

  isMobile(): boolean {
    return this.deviceDetectorService.isMobile() || this.deviceDetectorService.isTablet();
  }
}
